// iPadOS's visual viewport shrinks when the software keyboard opens. Keep the
// writing surface and footer inside that viewport without fighting pinch zoom.
export function installViewport() {
  const viewport = window.visualViewport;
  let frame = 0;
  const update = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (viewport && Math.abs(viewport.scale - 1) > 0.01) return;
      document.documentElement.style.setProperty('--writing-height', `${viewport?.height ?? innerHeight}px`);
      document.documentElement.style.setProperty('--writing-top', `${viewport?.offsetTop ?? 0}px`);
    });
  };
  viewport?.addEventListener('resize', update);
  viewport?.addEventListener('scroll', update);
  window.addEventListener('resize', update);
  update();
}
